import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import Styled from "components/finance/style";

bootstrapUtils.addStyle(Button, "grey");

function ReturnCapitalButton(props) {
  const { onClick, disabled, loading } = props;

  const style = disabled === true || loading === true ? "grey" : "primary";

  return (
    <Styled.UIButton
      className="btn-fn-decisions-button"
      bsStyle={style}
      onClick={onClick}
      disabled={disabled}
    >
      {loading === true ? "Loading..." : "Return Capital"}
    </Styled.UIButton>
  );
}

// get isReturnCapitalDisabled() {
//   const { currentRound } = this.state;

//   return currentRound === 1 ? true : false;
// }
export default ReturnCapitalButton;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/return-capital-button.js